export default __webpack_public_path__ + "static/media/icn_arrow_right.bcec2114.svg";